"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisableScroll = void 0;
const react_1 = require("react");
const keyCode_1 = require("./keyCode");
const useDisableScroll = ({ ref, activate }) => {
    (0, react_1.useEffect)(() => {
        if (!activate) {
            return;
        }
        const element = ref.current;
        const scrollKeys = {
            [keyCode_1.KeyCode.LeftArrow]: keyCode_1.KeyCode.LeftArrow,
            [keyCode_1.KeyCode.RightArrow]: true,
            [keyCode_1.KeyCode.DownArrow]: true,
            [keyCode_1.KeyCode.UpArrow]: true,
            [keyCode_1.KeyCode.Space]: true,
            [keyCode_1.KeyCode.PageDown]: true,
            [keyCode_1.KeyCode.PageUp]: true,
            [keyCode_1.KeyCode.End]: true,
            [keyCode_1.KeyCode.Home]: true
        };
        const onScroll = (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        const onKeydown = (e) => {
            if (scrollKeys[e.keyCode]) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        element === null || element === void 0 ? void 0 : element.addEventListener('wheel', onScroll, { capture: true });
        element === null || element === void 0 ? void 0 : element.addEventListener('keydown', onKeydown, { capture: true });
        return () => {
            element === null || element === void 0 ? void 0 : element.removeEventListener('wheel', onScroll, { capture: true });
            element === null || element === void 0 ? void 0 : element.removeEventListener('keydown', onKeydown, { capture: true });
        };
    }, [activate, ref]);
};
exports.useDisableScroll = useDisableScroll;
//# sourceMappingURL=useDisableScroll.js.map